import React, { Children, useMemo } from 'react'

function RoleWiseModulWrapper(props) {

    const filterModuleUsingPermissions = useMemo(() => {

        const data = props?.user?.role?.permissions_role?.filter((item2) => {
            return item2.is_accessible == true && item2.module_id
        });

        return props?.modules?.filter((item) => {
            return data?.find((item2) => {
                return item2?.module_id == item?.id;
            });
        });
    }, [props?.modules, props?.user?.role?.permissions_role]);

    const FindModuleName = useMemo(() => {
        return filterModuleUsingPermissions?.find((item) => {
            return item?.frontend_module_name === props?.module;
        })?.frontend_module_name;
    }, [filterModuleUsingPermissions, props?.module]);

    return (
        <div>
            {FindModuleName === props?.module ?
                props?.children :
                ""
            }
            {/* {props.children} */}
        </div>
    )
}

export default RoleWiseModulWrapper